import { render, staticRenderFns } from "./cancelCourseList.vue?vue&type=template&id=740fdba6&scoped=true&"
import script from "./cancelCourseList.vue?vue&type=script&lang=js&"
export * from "./cancelCourseList.vue?vue&type=script&lang=js&"
import style0 from "./cancelCourseList.vue?vue&type=style&index=0&id=740fdba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740fdba6",
  null
  
)

export default component.exports